import { render, staticRenderFns } from "./notepad.vue?vue&type=template&id=d73a5264&scoped=true&"
import script from "./notepad.vue?vue&type=script&lang=js&"
export * from "./notepad.vue?vue&type=script&lang=js&"
import style0 from "./notepad.vue?vue&type=style&index=0&id=d73a5264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73a5264",
  null
  
)

export default component.exports